import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { useGetLocationsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.form-validation';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as css from './emsp-bo-location-list-filter-search-form-step-1.module.scss';

export const EmspBoLocationListFilterSearchFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<GetLocationsPaginatedModel>();
    const { textToSearch } = useGetLocationsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="textToSearch"
        control={control}
        rules={textToSearch}
        render={({ field }) => (
          <TextInput
            className={css.searchInput}
            leftIcon="search-md"
            value={field.value}
            placeholder={t(
              'delmonicos-shared-sdk.inputs-filterable-fields-pagination.text-to-search',
            )}
            onChange={(e) => field.onChange(e.target.value)}
            adornment={
              field.value !== '' && (
                <Icon name="x-close" onClick={() => field.onChange('')} />
              )
            }
          />
        )}
      />
    );
  };
